import type { CSSProperties } from "react";

export type HeroTone = "light" | "dark";
export type HeroBackgroundVariant = "soft" | "bold";
export type HeroBackgroundMode = "gradient" | "solid";

export function getHeroTheme({
  tone,
  backgroundVariant = "soft",
  backgroundMode = "gradient",
}: {
  tone: HeroTone;
  backgroundVariant?: HeroBackgroundVariant;
  backgroundMode?: HeroBackgroundMode;
}) {
  const isDark = tone === "dark";
  const backgroundStyle: CSSProperties =
    backgroundMode === "solid"
      ? { backgroundColor: "var(--color-background)" }
      : {
          backgroundImage:
            backgroundVariant === "bold"
              ? "var(--gradient-hero-strong)"
              : "var(--gradient-hero-soft)",
        };
  const accentBlob = isDark ? "bg-accent/30" : "bg-primary/30";
  const primaryBlob = isDark ? "bg-primary/40" : "bg-primary/35";
  const eyebrowClasses = isDark
    ? "bg-white/10 text-white/80 ring-1 ring-white/15"
    : "bg-primary/10 text-slate-900 ring-1 ring-slate-900/20";
  const titleClasses = isDark ? "text-white drop-shadow-sm" : "text-[#0b4f6c]";
  const subtitleClasses = isDark ? "text-white/80" : "text-[#1f5f75]";
  const ctaNoteClasses = isDark ? "text-white/70" : "text-neutral-600";
  const outlineButtonClasses = isDark
    ? "bg-white/10 text-white border-white/30 hover:bg-white/15"
    : "bg-white/70 text-[color:var(--color-text,#1f1b2d)] border-white/80 hover:bg-white/85 shadow-md";

  return {
    isDark,
    backgroundStyle,
    accentBlob,
    primaryBlob,
    eyebrowClasses,
    titleClasses,
    subtitleClasses,
    ctaNoteClasses,
    outlineButtonClasses,
  };
}
